<div class="trend">
    <div class="panel">
        <mat-spinner class="spinner" [diameter]="40" *ngIf="!contentReady"></mat-spinner>
        <div class="center" *ngIf="contentReady" (dblclick)="resetZoom($event)">
            <canvas baseChart [data]="barChartData" [options]="barChartOptions" [type]="'bar'" *ngIf="contentReady">
            </canvas>
        </div>
    </div>
</div>